import React, { useState } from 'react';

const US_STATES = [
    'Alabama','Alaska','Arizona','Arkansas','California','Colorado','Connecticut',
    'Delaware','Florida','Georgia','Hawaii','Idaho','Illinois','Indiana','Iowa',
    'Kansas','Kentucky','Louisiana','Maine','Maryland','Massachusetts','Michigan',
    'Minnesota','Mississippi','Missouri','Montana','Nebraska','Nevada','New Hampshire',
    'New Jersey','New Mexico','New York','North Carolina','North Dakota','Ohio',
    'Oklahoma','Oregon','Pennsylvania','Rhode Island','South Carolina','South Dakota',
    'Tennessee','Texas','Utah','Vermont','Virginia','Washington','West Virginia',
    'Wisconsin','Wyoming', 'District of Columbia',
];

const formatPhone = (value) => {
    const digits = value.replace(/\D/g, '').slice(0, 10);
    if (digits.length <= 3) return digits;
    if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
};

const Step2Contact = ({ data, onChange }) => {
    const [errors, setErrors] = useState({});

    const validate = (field, value) => {
        const newErrors = { ...errors };
        if (field === 'email') {
            if (!value.trim()) {
                newErrors.email = 'Email address is required.';
            } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim())) {
                newErrors.email = 'Please enter a valid email address.';
            } else {
                delete newErrors.email;
            }
        }
        if (field === 'phone') {
            const digits = value.replace(/\D/g, '');
            if (value && digits.length > 0 && digits.length < 10) {
                newErrors.phone = 'Phone number must be 10 digits.';
            } else {
                delete newErrors.phone;
            }
        }
        setErrors(newErrors);
    };

    const handleChange = (field, value) => {
        validate(field, value);
        onChange(field, value);
    };

    const handlePhone = (value) => {
        const formatted = formatPhone(value);
        validate('phone', formatted);
        onChange('phone', formatted);
    };

    return (
        <div>
            <h2 className="step-title">Contact Information</h2>
            <p className="step-subtitle">How can customers reach you?</p>

            <div className="form-group">
                <label className="form-label">
                    Email Address <span className="required">*</span>
                </label>
                <input
                    type="email"
                    className={`form-input ${errors.email ? 'error' : ''}`}
                    placeholder="hello@yourbusiness.com"
                    value={data.email}
                    onChange={(e) => handleChange('email', e.target.value)}
                />
                {errors.email && (
                    <span className="field-error">{errors.email}</span>
                )}
            </div>

            <div className="form-group">
                <label className="form-label">Phone Number</label>
                <input
                    type="tel"
                    className={`form-input ${errors.phone ? 'error' : ''}`}
                    placeholder="(555) 555-5555"
                    value={data.phone}
                    onChange={(e) => handlePhone(e.target.value)}
                />
                {errors.phone && (
                    <span className="field-error">{errors.phone}</span>
                )}
            </div>

            <hr className="section-divider" />

            <div className="form-group">
                <label className="form-label">Street Address</label>
                <input
                    type="text"
                    className="form-input"
                    placeholder="123 Main Street"
                    value={data.street_address}
                    onChange={(e) => handleChange('street_address', e.target.value)}
                />
            </div>

            <div className="form-row">
                <div className="form-group">
                    <label className="form-label">City</label>
                    <input
                        type="text"
                        className="form-input"
                        placeholder="Springfield"
                        value={data.city}
                        onChange={(e) => handleChange('city', e.target.value)}
                    />
                </div>

                <div className="form-group">
                    <label className="form-label">State</label>
                    <select
                        className="form-select"
                        value={data.state}
                        onChange={(e) => handleChange('state', e.target.value)}
                    >
                        <option value="">— Select state —</option>
                        {US_STATES.map(s => (
                            <option key={s} value={s}>{s}</option>
                        ))}
                    </select>
                </div>
            </div>

            <div className="form-row">
                <div className="form-group">
                    <label className="form-label">ZIP Code</label>
                    <input
                        type="text"
                        className="form-input"
                        placeholder="12345"
                        value={data.zip_code}
                        onChange={(e) => handleChange('zip_code', e.target.value)}
                        maxLength={10}
                    />
                </div>

                <div className="form-group">
                    <label className="form-label">Country</label>
                    <select
                        className="form-select"
                        value={data.country}
                        onChange={(e) => handleChange('country', e.target.value)}
                    >
                        <option value="United States">United States</option>
                        <option value="Canada">Canada</option>
                        <option value="United Kingdom">United Kingdom</option>
                        <option value="Australia">Australia</option>
                        <option value="Other">Other</option>
                    </select>
                </div>
            </div>
        </div>
    );
};

export default Step2Contact;
